<template>
  <div>
    <aside id="leftsidebar" class="sidebar">
      <div class="navbar-brand">
        <button class="btn-menu ls-toggle-btn" type="button" v-on:click="toggleCollapseMenu">
          <i class="zmdi zmdi-menu"></i></button>
          <img class="pl-2" src="@/assets/images/logo.svg" width="180" alt="iteNlearning">
      </div>
      <!--<ul>
        <li><a href="#">Item 1</a>
            <ul class="sub-menu">
                <li><a href="#">Submenu</a></li>
                <li><a href="#">Submenu</a></li>
            </ul>
        </li>
        <li><a href="#">Item 2</a>
            <ul class="sub-menu">
                <li><a href="#">Submenu</a></li>
                <li><a href="#">Submenu</a></li>
            </ul>
        </li>
      </ul>-->
      <div class="menu">
        <div class="slimScrollDiv" style="position: relative; overflow: hidden; width: auto; height: calc(100vh - 65px);">
          <ul class="list" style="overflow: auto; width: auto; height: calc(100vh - 95px);">
            <li>
              <div class="user-info">
                <router-link to="/panel/users" class="image waves-effect waves-block" v-if="checkUserEdit()">
                  <img src="@/assets/images/profile_av.jpg" alt="Usuarios" title="Usuarios" >
                </router-link>
                <a @click="logout" href="#" class="image waves-effect waves-block" v-if="!checkUserEdit()">
                  <img src="@/assets/images/profile_av.jpg" alt="Usuarios" title="Usuarios" >
                </a>
                <div class="detail" v-if="user">
                  <h4>{{ user.nombre }}</h4>
                  <small>{{ user.empresa }}</small>
                </div>
              </div>
            </li>
            <li>
              <router-link to="/panel/contentbrowser" title="Organigrama">
                <i class="zmdi zmdi-home"></i>
                <span>Organigrama</span>
              </router-link>
            </li>
            <hr />
            <div v-if="checkUserEdit()">
              <li>
                <router-link to="/panel/images" title="Imágenes">
                  <i class="zmdi zmdi-image mr-1"></i>
                  <span>Imágenes</span>
                </router-link>
              </li>
              <li><router-link to="/panel/simbolicos" title="Simbolicos">
                  <i class="zmdi zmdi-book mr-1"></i>
                  <span>Simbólicos</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/audios" title="Audios">
                  <i class="zmdi zmdi-collection-music mr-1"></i>
                  <span>Audios</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/writtenorals" title="Consignas orales">
                  <i class="zmdi zmdi-mic-outline mr-1"></i>
                  <span>Consignas orales</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/texts" title="Textos">
                  <i class="zmdi zmdi-collection-text mr-1"></i>
                  <span>Textos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/writteninstructions" title="Consignas Escritas">
                  <i class="zmdi zmdi-comment-dots mr-1"></i>
                  <span>Consignas Escritas</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/contentsheets" title="Fichas de contenido">
                  <i class="zmdi zmdi-apps mr-1"></i>
                  <span>Fichas de contenido</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/geoplanos" title="Geoplanos">
                  <i class="zmdi zmdi-shape mr-1 "></i>
                  <span>Geoplanos</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/charts" title="Gráficos y Tablas">
                  <i class="zmdi zmdi-chart mr-1 "></i>
                  <span>Gráficos</span>
                </router-link>
              </li>
              <hr/>
              <li>
                <router-link to="/panel/statementsimple" title="Enunciados aritméticos">
                  <i class="zmdi zmdi-collection-text mr-1"></i>
                  <span>Enunciados aritméticos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/statementformula" title="Enunciados de fórmula">
                  <i class="zmdi zmdi-collection-text mr-1"></i>
                  <span>Enunciados fórmula</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/statementmultiple" title="Enunciados múltiples">
                  <i class="zmdi zmdi-collection-text mr-1"></i>
                  <span>Enunciados múltiples</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/unitmath" title="Unidades">
                  <i class="zmdi zmdi-explicit mr-1"></i>
                  <span>Unidades</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/formulas" title="Fórmulas">
                  <i class="zmdi zmdi-code-smartphone mr-1"></i>
                  <span>Fórmulas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/panel/templates" title="Plantillas">
                  <i class="zmdi zmdi-comment-dots mr-1"></i>
                  <span>Plantillas</span>
                </router-link>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import * as params from '../../env';

export default {
  name: 'leftsidebar',
  data() {
    return {
      user: null,
      togglemenu: {
        resources: false,
      },
    };
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
    this.user = user;

    // Automatically collapse left side for Viewer users
    if (!this.checkUserEdit()) {
      this.collapsedLeftSidebar = true;
    }

    window.$(() => {
      window.$('.sub-menu').hide();
      window.$('li:has(ul)').click(() => {
        window.$('ul', this).toggle('slow');
      });
    });
  },
  methods: {
    async logout() {
      this.loading = true;

      try {
        await this.axios.post('auth/logout');
        this.loading = false;
        localStorage.removeItem('token');
        localStorage.removeItem(params.default.USER_STORAGE);
        this.$router.push('/login');
      } catch (e) {
        this.loading = false;
        localStorage.removeItem('token');
        localStorage.removeItem(params.default.USER_STORAGE);
        this.$router.push('/login');
      }
    },
    toggleCollapseMenu() {
      this.collapsedLeftSidebar = !this.collapsedLeftSidebar;
      // console.log(this.collapsedLeftSidebar);
    },
  },
};

</script>
<style>
/*Style a Borrar, cuando se arregle el MENU LATERAL*/
.sidebar .menu .list a{
  padding: 5px 3px !important;
}
/*Style a Borrar, cuando se arregle el MENU LATERAL*/
</style>
